import { getText } from "shared/lib";

import { SubdivisionType } from "shared/hooks";

import { SubdivisionTimeline } from "./SubdivisionTimeline";

export interface SubdivisionPanelProps {
  subdivisionType: SubdivisionType;
}

export function SubdivisionPanel({ subdivisionType }: SubdivisionPanelProps) {
  const renderSubdivisionDetails = () => {
    switch (subdivisionType) {
      case SubdivisionType["subdivision of an approved development"]:
        return (
          <p className="text-textSubdued text-bodymd">
            {getText(
              "Because you already have an approved development, the subdivision process is more straightforward but it still requires careful attention to detail, particularly regarding service connections and building compliance. The process typically takes 4-8 months.",
            )}
          </p>
        );
      case SubdivisionType["battle-axe subdivision"]:
        return (
          <p className="text-textSubdued text-bodymd">
            {getText(
              "Subdivision can be complicated and has requirements beyond planning approval. For your proposal, the entire process typically takes 9-18 months and may have substantial costs.",
            )}
          </p>
        );
      case SubdivisionType["large lot subdivision in a rural area"]:
        return (
          <p className="text-textSubdued text-bodymd">
            {getText(
              "Subdivisions of large rural lots typically take 1–2 years to complete and involve significant costs. Council has policies to protect farmland and limit new lot creation in rural areas. Consult with a planner and land surveyor before making any major commitments.",
            )}
          </p>
        );
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <h3 className="text-headinglg text-textPrimary">
          The subdivision process
        </h3>

        {renderSubdivisionDetails()}
      </div>

      <SubdivisionTimeline subdivisionType={subdivisionType} />

      <p className="text-bodysm text-textSubdued">
        Timing and costs are estimates only. This information is general in
        nature and specific requirements will vary.
      </p>
    </div>
  );
}
